import React from 'react';
import PropTypes from 'prop-types';

const BurgerMenu = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 18">
    <path
      id="bx-menu-alt-right"
      d="M6,9H30v3H6Zm6,7.5H30v3H12ZM19.5,24H30v3H19.5Z"
      transform="translate(-6 -9)"
      fill={color}
    />
  </svg>

);

BurgerMenu.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

BurgerMenu.defaultProps = {
  width: 24,
  height: 18,
  color: '#fff',
};

export default BurgerMenu;
